/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import t from '@services/locale';

import { Box, Text } from '@components/atoms';
import { CustomContainer, Slider } from '@components/molecules';

const PriorityForm = ({
    control, formState: { errors }, questions,
}) => (
    <>
        {questions.map((item, index) => {
            if (item.field === 'SUBHEADING') {
                return (
                    <Box key={`subheading-${index}`} mb="3vh" mt="6vh">
                        <Text bold color="purple" fontSize={22}>
                            {item.statement}
                        </Text>
                        {item.context && (
                        <Text color="grey.600" fontSize={14} mt="1vh">
                            {item.context}
                        </Text>
                        )}
                    </Box>
                );
            }

            // eslint-disable-next-line no-console
            console.log(item);

            if (item.field === 'PRIORITY_TRIPLET') {
                return (
                    <CustomContainer bgColor="white" key={`triplet-${index}`} mb="4vh" p="2rem">
                        <Box display="flex" flexDirection="column" p="1rem" width="100%">
                            <Text bold fontSize={18} mb="1vh">
                                {item.statement}
                            </Text>
                            {item.context && (
                            <Text color="grey.700" fontSize={15} mb="2vh">
                                {item.context}
                            </Text>
                            )}

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                gap="2rem"
                                justifyContent="space-between"
                                mt="3vh"
                            >
                                {['axis1', 'axis2', 'axis3'].map((axisKey) => {
                                    // eslint-disable-next-line no-console
                                    console.log({ axisKey, item });
                                    const axis = item[axisKey];
                                    const questionIndex = axis.num_order - 1;

                                    return (
                                        <Box
                                            display="flex"
                                            flex={1}
                                            flexDirection="column"
                                            key={axisKey}
                                            minWidth="150px"
                                        >
                                            <Text bold color="grey.800" fontSize={14} mb="1vh">
                                                {axis.axis}
                                            </Text>

                                            <Slider
                                                control={control}
                                                error={errors?.answers?.[questionIndex]?.answer?.message}
                                                max={axis.maximum}
                                                max_label={t('Alta')}
                                                min={axis.minimum}
                                                min_label={t('Baixa')}
                                                name={`answers.${questionIndex}.answer`}
                                                steps={axis.maximum - 1}
                                                type="discrete"
                                            />
                                        </Box>
                                    );
                                })}
                            </Box>
                        </Box>
                    </CustomContainer>
                );
            }

            return null;
        })}
    </>
);

PriorityForm.propTypes = {
    control: PropTypes.shape({
        register: PropTypes.func,
    }).isRequired,
    formState: PropTypes.shape({
        errors: PropTypes.shape({
            answers: PropTypes.arrayOf(
                PropTypes.shape({
                    answer: PropTypes.shape({
                        message: PropTypes.string,
                    }),
                }),
            ),
        }),
    }).isRequired,
    questions: PropTypes.arrayOf(PropTypes.shape({
        context: PropTypes.string,
        field: PropTypes.string,
        gravity: PropTypes.object,
        statement: PropTypes.string,
        tendency: PropTypes.object,
        urgency: PropTypes.object,
        visibility_rule: PropTypes.shape({
            type: PropTypes.string,
        }),
    })).isRequired,
};

export default PriorityForm;
